module.exports = __webpack_public_path__ + "images/4c0a9f234db5fc966641cd12982f2141.user.svg";